module.exports = __webpack_public_path__ + "src/assets/img/pic (3).62c9992a.jpg";